import React, { memo } from "react";
import { fontConfig } from "theme/fontConfig";
import InfoTooltip from "components/InfoTooltip";

export const LabelField = memo(
  ({
    className,
    title,
    htmlFor,
    style,
    mandatory = false,
    children,
    color,
    hint,
    hintPlacement,
    ...rest
  }) => {
    const styles = {
      body: {
        fontSize: 14,
        fontFamily: fontConfig.LabelFieldBodyFont.family,
        textAlign: "start",
        color: "#3F4255",
        ...style,
      },
    };
    return (
      <div
        className={`d-felx justify-content-start text-truncate mb-1 ${className}`}
        style={{ ...style }}
      >
        <label
          style={{ ...styles.body, fontWeight: "500", ...(color !== undefined ? { color } : {}) }}
          {...{ htmlFor }}
          {...rest}
        >
          {title || children}
        </label>
        {mandatory && (
          <label
            style={{ ...styles.body, fontWeight: "500", color: "red" }}
            {...{ htmlFor }}
            {...rest}
          >
            {" *"}
          </label>
        )}
        {/* hint icon on the label's own line, after the label (and its "*") */}
        {hint && (
          <InfoTooltip
            text={hint}
            placement={hintPlacement}
            style={{ display: "inline-flex", verticalAlign: "middle", marginLeft: 6, position: "relative", top: -1 }}
          />
        )}
      </div>
    );
  }
);
